import React from "react";

const QuestionnaireValueBox = ({ value, ...props }) => {
  return (
    <div className="px-3 py-[0.675em] rounded-lg border border-main" {...props}>
      {value}
    </div>
  );
};

export default QuestionnaireValueBox;
